//declararamos datos iniciales en null
export const initialState = {};
